/**
 * #1316 review round 2 — a counter the share view moves at every session end that KEEPS its share session (the view
 * stays on the same sid: a sign-out in another tab for an unbound visit, a revoke the server did not confirm, a drive
 * tenant / identity switch). Something the end closed and that nothing else reopens (the share office socket, keyed on
 * the sid) depends on it to open again, as the session now here. An end that MOVES the share session
 * (`endMovesShareSession`) never moves it: the sid lags there, and the new sid is what reopens.
 */
import { useEffect, useState } from 'react'
import { endMovesShareSession, onSessionEnd } from '@papan/core-ui/ui/sessionEnded'

export function useShareSessionKeptNonce(): number {
  const [n, setN] = useState(0)
  useEffect(() => onSessionEnd((reason) => { if (!endMovesShareSession(reason)) setN((x) => x + 1) }), [])
  return n
}
